// Gets number of bytes to either mebibytes (MiB), kibibytes (KiB), or gibibytes (GB) depending on the unit
export const getNumOfBytes = (num: number, unit: 'KiB' | 'MiB' | 'GiB' | 'TiB'): number => {
  const sizes = {
    KiB: 1024,
    MiB: 1024 ** 2,
    GiB: 1024 ** 3,
    TiB: 1024 ** 4,
  };

  return num * sizes[unit];
};

export const getNumOfBytesFromString = (size: string): number => {
  const sizeArray = size.trim().split(' ');

  return getNumOfBytes(Number(sizeArray[0]), sizeArray[1] as 'KiB' | 'MiB' | 'GiB' | 'TiB');
};
